import styled from 'styled-components';

export const LeftSide = styled.div`
  width: 230px;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: var(--color-text-subtle);
  flex: 0 0 auto;

  h3 {
    margin: 0;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-muted);
    padding: 0 0 10px;
  }
`;
